/* import __COLOCATED_TEMPLATE__ from './descriptor-details-body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();